@if (isVisible()) {
    <div class="toast show position-fixed" [ngClass]="getToastClass()" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex px-3 align-items-center">
            <div class="toast-body">
                <h4 class="text-white fs-6 pt-2">{{ message }}</h4>
            </div>
            <!-- Close Button -->
            <button type="button" class="btn-close btn-close-white ms-auto" (click)="hide()" aria-label="Close"></button>
        </div>
    </div>
}